export default __webpack_public_path__ + "static/media/facebook.1306c344.svg";